import * as types from '../types';

const INITIAL_STATE = {
    offers: [],
    position: 0,
    interval: null,
    badgeText: 0,
    customers: undefined,
    filterdCustomers: [],
    userSearch: '',
    isDisabled: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.OFFERS_UPDATE_STATE:
            return { ...state, ...action.payload };
        case types.OFFERS_RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
